import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {DamagesActions} from '../store';
import {DamagesSelectors} from '../store/selectors';

@Injectable()
export class DamagesLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadDamagesDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadDamagesDone(): Observable<boolean> {
    return this.store.pipe(
      select(DamagesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(DamagesActions.ReadDamages());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
